import { pb } from '@/libs/pocketbase'
import { tryCatch } from '@/utils/try-catch'
import type { SearchDataPort, SearchQuery, SearchResult } from '../domain/search'

const appSearchAdapter: SearchDataPort = {
	async search(query: SearchQuery): Promise<SearchResult[]> {
		const params = new URLSearchParams()
		if (query.term.trim()) params.set('term', query.term.trim())
		params.set('limit', '8')

		const result = await tryCatch(pb.send<SearchResult[]>(`/api/search?${params.toString()}`, { method: 'GET', requestKey: null }))
		if (!result.isSuccess) throw new Error(result.error.message)
		return result.data
	},
}

export { appSearchAdapter }
